<template>
  <el-row :gutter="15">
    <el-col :span="24">
      <Filters
        class="mb-3"
        :resource="$sdk.carrier_contact"
        :filters.sync="filters"
        @apply="reload"
        @ready="load"
      />

      <el-card
        v-loading="isLoading"
        shadow="never"
      >
        <ContactsTable
          ref="contactTable"
          :contacts="contacts"
          @refresh="reload"
          @edit="showForm"
        />

        <el-pagination
          class="text-center pt-3"
          :current-page.sync="contacts.page"
          :page-size.sync="contacts.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="contacts.total"
          @size-change="reload"
          @current-change="reload"
        />

        <el-dialog
          :title="dialogTitle"
          :visible.sync="isShowing"
          :close-on-click-modal="false"
          :fullscreen="isFullscreen"
        >
          <ContactForm
            ref="ContactsForm"
            :contact="contact"
          />

          <template #footer>
            <el-button @click.native="isFullscreen = !isFullscreen">
              <FontAwesomeIcon
                :icon="['fal', (isFullscreen ? 'compress' : 'expand')]"
              />
            </el-button>

            <el-button @click.native="isShowing = false">
              Cancel
            </el-button>

            <el-button
              type="primary"
              :loading="isSaving"
              @click.native="$_.get(contact, 'id') ? update() : save()"
            >
              {{ $_.get(contact, 'id') ? 'Update' : 'Create' }}
            </el-button>
          </template>
        </el-dialog>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import ContactsTable from '@/components/Application/Manage/Carriers/ContactsTable'
import ContactForm from '@/components/Application/Manage/Carriers/ContactForm'
import Filters from '@/components/Filters/Complex'
import { CREATE } from '@/plugins/user'

export default {
  components: {
    ContactsTable,
    ContactForm,
    Filters
  },
  data () {
    return {
      title: 'Contacts',
      breadcrumb: {
        name: 'Contacts',
        route: { name: 'manage-carriers-carrier-contacts', params: { carrierId: this.$route.params.carrierId } }
      },
      actions: [
        {
          hidden: this.$user.cannot(CREATE, 'carrier_contact'),
          name: 'Create',
          icon: ['fal', 'plus'],
          event: this.showForm
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: this.reload
        }
      ],
      isLoading: true,
      isSaving: false,
      isShowing: false,
      isFullscreen: false,
      contacts: [],
      filters: [],
      contact: undefined
    }
  },
  computed: {
    dialogTitle () {
      return (this.isEditing ? 'Edit' : 'Create') + ' Carrier Contact'
    },
    isEditing () {
      return (this.contact && this.contact.id)
    }
  },
  methods: {
    load () {
      this
        .$sdk
        .carrier_contact
        .list((builder) => {
          builder.context = { resource: 'carrier', id: this.$route.params.carrierId }
          builder.filters = this.filters
        })
        .then(res => { this.contacts = res })
        .finally(() => { this.isLoading = false })
    },
    showForm (row) {
      if (row instanceof this.$sdk.carrier_contact) {
        this.contact = row.clone()
      } else {
        this.contact = new this.$sdk.carrier_contact()
      }

      this.isShowing = true
    },
    save () {
      this.isSaving = true
      this
        .contact
        .create((builder) => {
          builder.context = { resource: 'carrier', id: this.$route.params.carrierId }
        })
        .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
        .finally(() => {
          this.isSaving = false
          this.isShowing = false
          this.reload()
        })
    },
    update () {
      this.isSaving = true
      this.contact.update((builder) => {
        builder.context = { resource: 'carrier', id: this.$route.params.carrierId }
      })
        .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
        .finally(() => {
          this.isSaving = false
          this.isShowing = false
          this.reload()
        })
    },
    async reload () {
      this.isLoading = true

      try {
        await this.contacts.reload(builder => { builder.filters = this.filters })
      } catch {
        this.$message.error('An error occurred while loading the contacts')
      }

      this.isLoading = false
    }
  }
}
</script>
